import kslEmailService from './kslEmailService';

// Service d'envoi d'email principal
export const emailService = {
  // Envoyer un email de contact
  sendContactEmail: async (contactData) => {
    try {
      console.log('📧 [emailService.sendContactEmail] → Envoi email contact:', contactData);
      
      // Utiliser le service d'email KSL (vrai envoi)
      const result = await kslEmailService.sendContactEmail(contactData);
      
      console.log('✅ Email envoyé avec succès via kslEmailService');
      return result;
      
    } catch (error) {
      console.error('❌ Erreur envoi email:', error);
      throw new Error(`Erreur lors de l'envoi de l'email: ${error.message}`);
    }
  },

  // Envoyer un email de notification interne
  sendInternalNotification: async (notificationData) => {
    try {
      console.log('📧 [emailService.sendInternalNotification] → Envoi notification:', notificationData);
      
      // Simuler l'envoi de notification
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      console.log('✅ Notification simulée envoyée');
      return { 
        success: true, 
        messageId: `notification_${Date.now()}`,
        timestamp: new Date().toISOString()
      };
      
    } catch (error) {
      console.error('❌ Erreur envoi notification:', error);
      throw error;
    }
  },

  // Valider un email
  validateEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  // Valider les données du formulaire de contact
  validateContactForm: (formData) => {
    const errors = {};
    
    if (!formData.name || formData.name.trim().length < 2) {
      errors.name = 'Le nom doit contenir au moins 2 caractères';
    }
    
    if (!formData.email || !emailService.validateEmail(formData.email)) {
      errors.email = 'Veuillez entrer une adresse email valide';
    }
    
    if (!formData.subject || formData.subject.trim().length === 0) {
      errors.subject = 'Veuillez sélectionner un sujet';
    }
    
    if (!formData.message || formData.message.trim().length < 10) {
      errors.message = 'Le message doit contenir au moins 10 caractères';
    }
    
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};

export default emailService;
